const utils = require('../../../lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'select'
	],

	// config: {
	// 	componentConfig: {
	// 		resourceRegisterKey: 'fieldNameDef???'
	// 	}
	// },

	methods: {
		prepare: function(){
			var dataAttributeKey;
			if(this.model.atom && !!this.model.atom.dataType){
				dataAttributeKey = this.model.atom.dataType + '-data';
			} else {
				dataAttributeKey = 'data';
			}

			// prepare options
			this.model[dataAttributeKey] = this.resourceData.options;
		}
	}
}